import _ from 'lodash';
import classNames from 'classnames';
import React, { Component, PropTypes } from 'react';
import { mapAdSizeById } from '../utils/AdUtils';
import { onScroll, offScroll } from '../utils/WindowUtils';
import connect from 'connect-alt';

const LAZY_LOAD_DISTANCE = 200;

/**
 * Class representing an ad unit on the website.
 */
@connect('Advertisement')
class AdvertisementUnit extends Component {
  static propTypes = {
    AdvertisementStore: PropTypes.object.isRequired,
    className: PropTypes.string,
    adData: PropTypes.object,
    isAutoAd: PropTypes.bool,
    isLazyAd: PropTypes.bool
  };

  static contextTypes = {
    flux: PropTypes.object.isRequired
  }

  state = {
    rendered: false
  }

  componentDidMount() {
    const {
      adData: {
        id
      } = {}
    } = this.props;

    if (this._isLazyLoad()) {
      this._startLazyLoadAd(id);
    } else {
      this._renderAd(id);
    }
  }

  componentDidUpdate() {
    const Worldnow = window['Worldnow'];
    const {
      adData: {
        id
      } = {},
      AdvertisementStore: {
        targetKeys = {}
      }
    } = this.props;

    const options = this._generateAdUnitOptions();

    /** use rebuild to make the ad unit reload completely */
    _.assign(options, { rebuild: true });

    /** Get wncid from franklyDataLayer > feature_id */
    const franklyDataLayer = window['franklyDataLayer'] || [{}];
    const [{ feature_id }] = franklyDataLayer;
    targetKeys.wncid = feature_id;

    /** Put any targeting key in store to AdMan */
    _.assign(Worldnow.AdMan.options, targetKeys);

    window.addEventListener('load', () => {
      /** Force AdMan to perform targeting again and reload the ads */
      Worldnow.AdMan.load();
      window.GPT_PAGE_TARGETING_DONE = false;

      // This line started to cause ads to load twice. There is no documentation or apparent reason on why we needed .load() and .reload().
      // Removing it solved the issue. We'll QA this way, until we prove there is still a need for it.
      // Worldnow.AdMan.reloadAd(id, options);

      // removing the previous line caused a compling error for not using the "id" anywhere in the component
      // to limit major code changes removing, added a temporary use for it until we prove we're going in the right direction.
      options.idTemp = id;
    });
  }

  componentWillUnmount() {
    offScroll(this._renderAdOnScrollListener);
  }

  _isLazyLoad() {
    const { isLazyAd: componentEnableLazyAd } = this.props;

    const franklyDataLayer = window['franklyDataLayer'] || [{}];

    const [{ adSettings: { enableLazyAds: appEnableLazyAds = false } = {} }] = franklyDataLayer;

    return componentEnableLazyAd === undefined ? appEnableLazyAds : componentEnableLazyAd;
  }

  _startLazyLoadAd(id) {
    const adElement = document.getElementById(`WNAd${id}`);

    if (this._isAdInViewPort(adElement)) {
      this._renderAd(id);
    } else {
      this._renderAdOnScrollListener = onScroll({
        ratio: 0,
        element: adElement,
        delta: 0 - (LAZY_LOAD_DISTANCE + window.innerHeight)
      }, () => {
        const { rendered } = this.state;

        if (!rendered) {
          this._renderAd(id);

          this.setState({rendered: true});
        }
      });
    }
  }

  _isAdInViewPort(adElement) {
    const $ = window['$'];

    return $(adElement).offset().top < $(window).scrollTop() + window.innerHeight;
  }

  _generateAdUnitOptions() {
    let { adData = {}, isAutoAd } = this.props;
    const { flux } = this.context;

    adData = _.omitBy(adData, (val) => val === "");
    const { id, wncc } = adData;

    const contentClassification = wncc || flux.getStore('ContentClassification').getState().contentClassification;

    const defaultAdData = {
      wnsz: id,
      parent: "WNAd" + id,
      type: "dom",
      application: "banner",
      wncc: contentClassification
    };

    if (isAutoAd) {
      _.assign(defaultAdData, mapAdSizeById(id));
    }

    const options = _.defaults(_.cloneDeep(adData), defaultAdData);

    return options;
  }

  _renderAd(id) {
    const Worldnow = window['Worldnow'];

    const options = this._generateAdUnitOptions();

    const existingAds = Worldnow.AdMan.getAds(id);

    /** Ads with same id that has been loaded before cause the error. Need to be rebuilt to render properly
     * For single page
    */
    if (existingAds.length) {
      _.assign(options, { rebuild: true });

      Worldnow.AdMan.reloadAd(id, options);
    } else {
      const adUnit = new Worldnow.Ad(options);
      Worldnow.AdMan.start();
      adUnit.load();
    }
  }

  render() {
    const {
       adData = {},
       className: classNameProp,
       AdvertisementStore: {
         showAds = true
       }
    } = this.props;

    const className = classNames('AdvertisementUnit',
      classNameProp,
      { 'adhesion': adData.adhesion }
    );

    if (!showAds) {
      return null;
    }

    return (
     <div className={className} id={"WNAd" + adData.id}></div>
    );
  }

}

export default AdvertisementUnit;



// WEBPACK FOOTER //
// ./app/components/AdvertisementUnit.js